import React, { useState, useEffect } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";
import { FreeMode, Pagination } from "swiper/modules";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { FaPlus, FaMinus, FaCheckCircle } from "react-icons/fa";
import { addToWishlist } from "../../utils/wishlistUtils";
import { removeFromCart, getCartCount } from "../../utils/cartUtils";
import { Link } from "react-router-dom";
import emptyCart from "../../assets/Shopping-Cart-PNG-Image.png";
// import Payment1 from "../Payment/Payment1";

const Cart0 = ({ data, fetchCartList }) => {
  const [cartProductCount, setProductCount] = useState(0);
  const [totalPaidPrice, setTotalPaidPrice] = useState(0);
  const [totalPrice, setTotalPrice] = useState(0); //excluding delivery charge
  const [pincodeDeliveryCharge, setPincodeDeliveryCharge] = useState(0);
  const [cartData, setCartData] = useState([]);
  const [products, setProducts] = useState([]);
  const [wishlistCount, setWishlistCount] = useState(0);
  const [wishList, setWishList] = useState([]);
  const navigate = useNavigate();
  const admin_auto_id = sessionStorage.getItem("admin_auto_id");
  const app_type_id = sessionStorage.getItem("app_type_id");
  const user_auto_id = sessionStorage.getItem("accessToken");
  const [wishlistChanged, setWishlistChanged] = useState(false);
  const [cartCount, setCartCount] = useState(0);
  const quantityTimeouts = {};
  const [themeColor, setThemeColor] = useState("#000000")
  const [themeIconColor, setThemeIconColor] = useState("#000000");
  const [similarProducts, setSimilarProducts] = useState({});

  useEffect(() => {
    const storedStyle = sessionStorage.getItem("UIStyle");
    if (storedStyle) {
      const parsedStyle = JSON.parse(storedStyle);
      setThemeColor(parsedStyle.web_theme_colour);
      setThemeIconColor(parsedStyle.web_theme_icon_color
      );
    }
  }, []);


  useEffect(() => {
    if (cartData.length === 0) {
      setTotalPaidPrice(0);
      setTotalPrice(0);
      setProductCount(0);
      setPincodeDeliveryCharge(0);
    }
  }, [cartData]);

  useEffect(() => {
    if (data && data.get_admin_cart_product_lists) {
      setCartData(data.get_admin_cart_product_lists);
      setProductCount(data.get_admin_cart_product_lists.length);
    }
    if (data && data.pincode_delivery_charge) {
      setPincodeDeliveryCharge(parseInt(data.pincode_delivery_charge));
    }
    if (data && data.total_paid_price) {
      setTotalPaidPrice(parseInt(data.total_paid_price));
    }
    if (data && data.total_price) {
      setTotalPrice(parseInt(data.total_price));
    }
  }, [data]);

  const updateCartQuantity = async (
    cartProductAutoId,
    newQuantity,
    user_seleted_size
  ) => {
    try {
      await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/edit_cart_product`,
        {
          cart_product_auto_id: cartProductAutoId,
          cart_quantity: newQuantity,
          size: user_seleted_size,
        }
      );

      fetchCartList();
    } catch (error) {
      console.error("Error updating cart:", error);
    }
  };

  const handleQuantityChange = (
    cartProductAutoId,
    quantity,
    user_seleted_size,
    moq
  ) => {
    const moqNumber = moq ? parseInt(moq, 10) : 1; // Convert MOQ to number, default to 1 if not present
    const newQuantity = isNaN(quantity) || quantity < moqNumber ? moqNumber : quantity;

    setCartData((prevCart) =>
      prevCart.map((item) =>
        item.cart_product_auto_id === cartProductAutoId
          ? { ...item, cart_quantity: quantity }
          : item
      )
    );

    if (quantityTimeouts[cartProductAutoId]) {
      clearTimeout(quantityTimeouts[cartProductAutoId]);
    }

    quantityTimeouts[cartProductAutoId] = setTimeout(() => {
      updateCartQuantity(cartProductAutoId, quantity, user_seleted_size);

    }, 1000);
  };

  const fetchRecommendedProducts = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_recommended_products`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          customer_auto_id: sessionStorage.getItem("admin_auto_id"),
          app_type_id: sessionStorage.getItem("app_type_id"),
        }
      );

      if (response.data.status === 1) {
        const rawProducts = response.data.get_recommended_products_lists;

        const mappedProducts = rawProducts.map((item, index) => ({
          id: index + 1,
          name: item.product_name,
          description: item.description,
          img: item.product_images?.[0]
            ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0].product_image}`
            : "https://via.placeholder.com/150",
          price: `INR ${item.get_price_lists?.[0]?.final_size_price ?? "0.00"}`,
          product_auto_id: item.product_auto_id,
        }));

        setProducts(mappedProducts);
      } else {
        console.error("Failed to fetch products:", response.data.msg);
      }
    } catch (error) {
      console.error("API error:", error);
    }
  };

  const fetchSimilarProducts = async (cartItem) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_simillar_products`,
        {
          admin_auto_id,
          customer_auto_id: admin_auto_id,
          app_type_id,
          product_auto_id: cartItem.product_auto_id,
          sub_category_auto_id: cartItem.sub_category_auto_id,
        }
      );

      if (response.data.status === 1) {
        const rawSimilarProducts = response.data.get_similar_product_lists;
        const mappedSimilarProducts = rawSimilarProducts.map((item, index) => ({
          id: index + 1,
          name: item.product_name,
          description: item.description,
          img: item.product_images?.[0]
            ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0].product_image}`
            : "https://via.placeholder.com/150",
          price: `INR ${item.final_product_price ?? "0.00"}`,
          product_auto_id: item.product_auto_id,
        }));
        setSimilarProducts((prev) => ({
          ...prev,
          [cartItem.cart_product_auto_id]: mappedSimilarProducts,
        }));
      } else {
        setSimilarProducts((prev) => ({
          ...prev,
          [cartItem.cart_product_auto_id]: [],
        }));
        console.error("Failed to fetch similar products:", response.data.msg);
      }
    } catch (error) {
      console.error("API error for similar products:", error);
      setSimilarProducts((prev) => ({
        ...prev,
        [cartItem.cart_product_auto_id]: [],
      }));
    }
  };

  const handleCheckout = async () => {
    const admin_auto_id = sessionStorage.getItem("admin_auto_id");
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_shop_status`,
        {
          admin_auto_id,
        }
      );

      if (response.data.status === 1) {
        if (response.data.shop_status == "OFF") {
          navigate("/shop-closed");
        } else {
          navigate("/checkout");
        }
      } else {
        navigate("/checkout");
      }
    } catch (error) {
      // console.error("Error checking shop status:", error);
      navigate("/checkout");
      // Optionally, show an error message
    }
  };

  const fetchWishlistCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setWishlistCount(res.data.product_count_data);
      } else {
        setWishlistCount(0);
      }
    } catch (error) {
      setWishlistCount(0);
      console.error("Error fetching wishlist count:", error);
    }
  };

  const fetchCartCount = async () => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_cart_product_count`,
        {
          admin_auto_id: sessionStorage.getItem("admin_auto_id"),
          user_auto_id: sessionStorage.getItem("accessToken"),
        }
      );
      if (res.data.status === 1) {
        setCartCount(res.data.product_count_data);
      } else {
        setCartCount(0);
      }
    } catch (error) {
      setCartCount(0);
      console.error("Error fetching cart count:", error);
    }
  };

  const fetchWishlist = async () => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_BASE_URL}/get_wishlist`,
        {
          admin_auto_id,
          limit: 10,
          page_number: 1,
          user_auto_id,
        }
      );

      if (response.data.status === 1) {
        setWishList(response.data.get_admin_wishlist_product_lists || []);
      } else {
        setWishList([]);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
      setWishList([]);
    }
  };

  useEffect(() => {
    fetchRecommendedProducts();
  }, []);

  useEffect(() => {
    fetchWishlistCount();
    fetchWishlist();
    fetchCartCount();
  }, [wishlistChanged]);


  useEffect(() => {
    cartData.forEach((item) => {
      fetchSimilarProducts(item);
    });
  }, [cartData, cartCount]);

  return (
    <>
      {cartData?.length > 0 ? (
        <div className="flex flex-col gap-6 p-3 mx-auto bg-white md:p-0 max-w-7xl md:flex-row md:justify-between">
          {/* Left Section - Shopping Bag */}
          <div className="md:w-4/5">
            <h2 className="flex items-center justify-between text-lg font-semibold">
              <span>
                Shopping Bag{" "}
                <span className="text-gray-500">({cartProductCount})</span>
              </span>
              <span
                className="flex items-center text-lg underline cursor-pointer hover:underline"
                onClick={() => navigate("/")}
                style={{ color: themeColor }}
              >
                <MdOutlineKeyboardArrowLeft className="text-xl" style={{ color: themeColor }} />
                See More
              </span>
            </h2>
            <p className="mt-1 text-sm text-gray-500">
              Your bag contains {cartProductCount} item and comes to a total of
              INR {totalPaidPrice}
            </p>

            {/* Product Card */}
            <div className="max-h-[350px] overflow-y-auto">
              {cartData?.map((item, index) => {
                const finalproductprice = parseFloat(
                  item.final_product_price || 0
                );
                const isInStock = Number(item.available_stock) > 0;
                const moqNumber = item.moq ? parseInt(item.moq, 10) : 1;
                return (
                  <div
                    key={index}
                    className="
    flex items-start gap-2 pt-2  mt-4 
    bg-gray-100 rounded-lg

    /* Mobile View */
    flex-row

    /* Desktop View (No Changes) */
    md:flex-nowrap
  "
                  >

                    <img
                      src={
                        item.product_images &&
                          item.product_images.length > 0 &&
                          item.product_images[0]?.image_file
                          ? `https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${item.product_images[0].image_file}`
                          : "https://via.placeholder.com/150"
                      }
                      alt={item.product_name}
                      className="object-cover w-20 h-32 rounded-lg md:w-28 md:h-40"

                    />
                    <div className="flex-1 pr-2">
                      <div className="flex items-start justify-between md:items-center">

                        {/* PRODUCT NAME — smaller width on mobile */}
                        <h3 className="text-base font-semibold leading-tight md:text-lg w-[55%] md:w-auto">
                          {item.product_name}
                        </h3>

                        {/* PRICE SECTION — bigger width on mobile */}
                        <div className="w-[45%] md:w-auto flex flex-col items-end">

                          {/* PRICE ROW */}
                          <div className="flex flex-col items-end md:flex-row md:gap-2 whitespace-nowrap">

                            {/* Show old price ONLY if offer > 0 */}
                            {item.product_offer_percentage > 0 && (
                              <span className="mt-1 text-sm font-semibold line-through">
                                INR {item.product_price}
                              </span>
                            )}

                            {/* Always show final price */}
                            <span className="text-lg font-semibold">
                              INR {finalproductprice.toFixed(2)}
                            </span>
                          </div>

                          {/* OFFER BADGE — only if offer > 0 */}
                          {item.product_offer_percentage > 0 && (
                            <div
                              className="flex justify-center w-20 p-1 mt-1 rounded-full"
                              style={{ backgroundColor: themeColor }}
                            >
                              <span className="flex text-white">
                                {item.product_offer_percentage}%
                              </span>
                            </div>
                          )}

                        </div>
                      </div>

                      {isInStock && (
                        <span className="mt-0 font-medium" style={{ color: themeColor }}>
                          In Stock
                        </span>
                      )}
                      {/* Size & Quantity */}
                      <div className="flex flex-wrap md:gap-4 md:mt-3">
                        {item.size?.some((s) => s.size_auto_id === item.user_seleted_size) && (
                          <div className="flex items-center gap-2">
                            <h4 className="mt-2 text-sm font-semibold">Size:</h4>
                            <span className="text-sm ">
                              {item.size?.find(
                                (s) => s.size_auto_id === item.user_seleted_size
                              )?.size_name || "N/A"}
                            </span>
                          </div>
                        )}


                        <div className="flex items-center gap-2 ">
                          <h4 className="mt-2 text-sm font-semibold ">
                            Quantity:
                          </h4>
                          <div className="flex items-center px-2 bg-white border rounded-full shadow-sm ">
                            <button
                              className="p-2 text-gray-600 hover:text-black"
                              onClick={() => {
                                const newQuantity =
                                  Number(item.cart_quantity) - 1;
                                if (newQuantity >= moqNumber) {
                                  handleQuantityChange(
                                    item.cart_product_auto_id,
                                    newQuantity,
                                    item.user_seleted_size,
                                    item.moq
                                  );
                                }
                              }}
                              disabled={Number(item.cart_quantity) <= 1}
                            >
                              <FaMinus />
                            </button>

                            <input
                              type="number"
                              min="1"
                              value={item.cart_quantity}
                              onChange={(e) => {
                                const value = parseInt(e.target.value);
                                const newQuantity = isNaN(value) || value < moqNumber ? moqNumber : value;
                                handleQuantityChange(
                                  item.cart_product_auto_id,
                                  newQuantity,
                                  item.user_seleted_size,
                                  item.moq
                                );
                              }}
                              className="w-16 text-center outline-none border-x "
                            />

                            <button
                              className="p-2 text-gray-600 hover:text-black"
                              onClick={() => {
                                const newQuantity =
                                  Number(item.cart_quantity) + 1;
                                handleQuantityChange(
                                  item.cart_product_auto_id,
                                  newQuantity,
                                  item.user_seleted_size,
                                  item.moq
                                );
                              }}
                            >
                              <FaPlus />
                            </button>
                          </div>
                        </div>
                      </div>

                      {/* Customizable Label */}
                      {item.Customizable === "Yes" && item.cust_image && (
                        <div className="flex items-center gap-2 mt-2">
                          <FaCheckCircle className="text-green-600" />
                          <span className="text-sm font-medium text-green-600">
                            Customization saved
                          </span>
                        </div>
                      )}

                      {/* Action Buttons */}
                      <div className="flex justify-end gap-2 mt-3 mb-3">


                        <button
                          className="px-3 py-1 text-sm font-semibold transition bg-white border-black rounded-full border-1"
                          onClick={async () => {
                            try {
                              const res = await addToWishlist(
                                item.product_auto_id
                              );
                              console.log("addToWishlist response:", res);

                              if (res?.status === "1") {
                                await removeFromCart(item.product_auto_id);
                                fetchCartList();
                                fetchCartCount();

                                // Immediately remove the item from local state
                                setCartData((prev) =>
                                  prev.filter(
                                    (p) =>
                                      p.cart_product_auto_id !==
                                      item.cart_product_auto_id
                                  )
                                );

                                setProductCount((prev) => prev - 1);
                                setSimilarProducts((prev) => {
                                  const updated = { ...prev };
                                  delete updated[item.cart_product_auto_id];
                                  return updated;
                                });
                                fetchCartList(); // Still fetch to re-sync with backend
                                fetchCartCount();

                                // Trigger wishlist fetch
                                setWishlistChanged((prev) => !prev);
                              }
                            } catch (error) {
                              console.error("Save for later failed:", error);
                            }
                          }}
                        >
                          Save For Later
                        </button>
                        <button
                          className="px-3 py-1 text-sm font-semibold text-black transition bg-white border-black rounded-full border-1"
                          onClick={async () => {
                            try {
                              await removeFromCart(item.product_auto_id);
                              fetchCartList();

                              // Immediately remove the item from local state
                              setCartData((prev) =>
                                prev.filter(
                                  (p) =>
                                    p.cart_product_auto_id !==
                                    item.cart_product_auto_id
                                )
                              );

                              setProductCount((prev) => prev - 1);
                              setSimilarProducts((prev) => {
                                const updated = { ...prev };
                                delete updated[item.cart_product_auto_id];
                                return updated;
                              });
                              fetchCartList(); // Still fetch to re-sync with backend
                            } catch (error) {
                              console.error("Error removing product:", error);
                            }
                          }}
                        >
                          Remove
                        </button>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            <div
              className="
    gap-2 p-3 mt-4 
    bg-gray-100 rounded-lg block md:hidden

    /* Mobile: column layout */
    flex flex-col

    /* Desktop: keep original */
    md:flex md:flex-col
  "
            >
              {/* Product Details Header */}
              <h2 className="flex items-center justify-between text-lg font-semibold">
                <span>
                  Product Details{" "}
                  <span className="text-gray-500">({cartProductCount})</span>
                </span>
              </h2>

              {/* Order Total Row */}
              <div className="flex items-start justify-between w-full mt-0 "
              >
                {/* Left: Title */}
                <h3 className="text-lg font-semibold">Orders Total :</h3>

                {/* Right: Price + small text */}
                <div className="text-right">
                  <span className="block text-lg font-semibold">{totalPrice}</span>
                  <p className="text-xs text-gray-500">
                    Excluding Delivery (INR {pincodeDeliveryCharge})
                  </p>
                </div>
              </div>

              {/* Total Amount Row */}
              <div className="flex items-start justify-between w-full mt-0 "
              >
                {/* Left: Title */}
                <h3 className="text-lg font-semibold">Total Amount:</h3>

                {/* Right: Price + small text */}
                <div className="text-right">
                  <span className="block text-lg font-semibold">
                    INR {totalPaidPrice}
                  </span>
                  <p className="text-xs text-gray-500">
                    Including Delivery (INR {pincodeDeliveryCharge})
                  </p>
                </div>
              </div>

            </div>


            {/* Total Summary */}
            <div className="flex flex-col items-end hidden p-3 mt-4 bg-white md:block">
              <h3 className="text-lg font-semibold">
                <span className="mr-20">Total</span> Rs:{" "}
                <span>{totalPrice}</span>
              </h3>
              <p className="mt-1 text-sm text-gray-500">
                Excluding Standard Delivery (Normally INR{" "}
                {pincodeDeliveryCharge})
              </p>

              {/* <button className="p-2 text-white bg-blue-500 rounded-md">Apply Coupon</button> */}
            </div>

            {/* See More */}
            <div className="flex flex-col items-start hidden bg-white md:block">
              <span
                className="flex items-start text-lg font-bold underline cursor-pointer hover:underline"
                onClick={() => navigate("/")}
                style={{ color: themeColor }}
              >
                <MdOutlineKeyboardArrowLeft className="mt-1 text-2xl " style={{ color: themeColor }} />
                See More
              </span>
            </div>

            {/* Saved for Later Section */}
            {wishList.length > 0 && (
              <div className="mt-6">
                <h3 className="mb-2 text-lg font-semibold">
                  Saved For Later{" "}
                  <span className="text-gray-500">({wishlistCount})</span>
                </h3>

                <div className="overflow-x-auto whitespace-nowrap scrollbar-hide">
                  <div className="flex gap-4">
                    {wishList.map((product) => (
                      <Link
                        to={`/product-detail/${product.product_auto_id}`}
                        className="no-underline text-inherit"
                      >
                        <div
                          key={product.product_auto_id}
                          className="flex-shrink-0 inline-block w-48 p-2 bg-white border rounded-lg shadow"
                        >
                          <img
                            src={`https://grobizapp-n.s3.ap-south-1.amazonaws.com/products_images/${product.product_images[0]?.product_image}`}
                            alt={product.product_name}
                            className="object-cover w-full h-40 rounded-md"
                          />
                          <h4 className="mt-2 text-sm font-semibold truncate">
                            {product.product_name}
                          </h4>
                          <p className="text-xs text-gray-500 truncate">
                            {product.description}
                          </p>
                          {product.final_product_price && (
                            <p className="mt-1 text-sm font-bold">
                              ₹{product.final_product_price}
                            </p>
                          )}
                        </div>
                      </Link>
                    ))}
                  </div>
                </div>
              </div>
            )}

            <div className="">
              <p className="hidden p-1 mt-1 text-sm text-gray-500 text-start md:block">
                here as you save them from your shopping bag Items will appear.
              </p>
            </div>
          </div>



          {/* Right Section - Checkout Summary */}
          <div className="bg-white md:p-4 md:w-1/4 ">
            <div className="flex items-start justify-between hidden md:block">
              <h3 className="text-lg font-semibold">Total:</h3>
              <div className="text-right">
                <span className="block text-lg font-semibold">
                  INR {totalPaidPrice}
                </span>
                <p className="text-xs text-gray-500">
                  Including Standard Delivery (Normally INR{" "}
                  {pincodeDeliveryCharge})
                </p>
              </div>
            </div>
            {/* Checkout Button */}
            <button
              className="w-full py-2 text-sm font-semibold text-white transition rounded-full md:mt-4 hover:bg-teal-700"
              onClick={handleCheckout}
              // Show Payment component
              style={{ backgroundColor: themeColor }}
            >
              Checkout
            </button>
          </div>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center mt-3 gap-y-1">
          <div className="w-52 h-52 ">
            <img src={emptyCart} alt="empty Shopping Cart" />
          </div>
          <div className="-mt-10">
            <p className="mb-0 text-2xl font-bold">
              Your Shopping Bag is empty
            </p>
          </div>
          <div>
            <p>This feels too light! Go on, add all your favourites</p>
          </div>
          <button
            className="p-2 text-white bg-black "
            onClick={() => navigate("/")}
          >
            Start Shopping
          </button>
        </div>
      )}

      {/* Similar Products Section */}
      {Object.keys(similarProducts).length > 0 && (
        <div className="w-full px-12 py-6 bg-white">
          <h2 className="text-lg font-semibold text-start">Similar Products</h2>
          <div className="mt-6">
            <Swiper
              slidesPerView={9}
              spaceBetween={10}
              freeMode={true}
              breakpoints={{
                320: { slidesPerView: 2.5 },
                640: { slidesPerView: 3 },
                1024: { slidesPerView: 6 },
                1280: { slidesPerView: 9 },
              }}
              modules={[FreeMode]}
              className="mySwiper"
            >
              {Object.values(similarProducts).flat().map((similarItem, index) => (
                <SwiperSlide key={`${similarItem.id}-${index}`}>
                  <Link
                    to={`/product-detail/${similarItem.product_auto_id}`}
                    className="no-underline text-inherit"
                  >
                    <div className="flex flex-col items-start w-full h-64 bg-white">
                      <img
                        src={similarItem.img}
                        alt={similarItem.name}
                        className="object-cover w-full h-48 rounded-md"
                      />
                      <div className="p-1 py-0">
                        <h3 className="text-sm font-semibold text-black">{similarItem.price}</h3>
                        <h3 className="text-sm font-medium">
                          {similarItem.name.length > 10 ? similarItem.name.slice(0, 10) + "..." : similarItem.name}
                        </h3>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}

      {/* Full-Width Row (Outside the max-w-7xl container) */}
      {products.length > 0 && (
        <div className="w-full px-10 py-6 bg-white">
          <h2 className="text-lg font-semibold text-start">Recommended</h2>


          {/* Swiper Slider */}
          <div className="mt-6">
            <Swiper
              slidesPerView={9} // Show 9 slides at a time
              spaceBetween={10} // Space between slides
              freeMode={true}
              breakpoints={{
                320: { slidesPerView: 2.5 }, // On small screens, show 2 slides
                640: { slidesPerView: 3 }, // On tablets, show 3 slides
                1024: { slidesPerView: 6 }, // On medium screens, show 6 slides
                1280: { slidesPerView: 9 }, // On large screens, show 9 slides
              }}
              modules={[FreeMode]}
              className="mySwiper"
            >
              {/* Generate slides dynamically */}
              {products.map((item) => (
                <SwiperSlide key={item.id}>
                  <Link
                    to={`/product-detail/${item.product_auto_id}`}
                    className="no-underline text-inherit"
                  >
                    <div className="flex flex-col items-start w-full h-64 bg-white">
                      {/* Image */}
                      <img
                        src={item.img}
                        alt={item.name}
                        className="object-cover w-full h-48 rounded-md"
                      />

                      <div className="p-1 py-0">
                        {/* Price */}
                        <h3 className="text-sm font-semibold text-black">
                          {item.price}
                        </h3>

                        {/* Name */}
                        <h3 className="text-sm font-medium">
                          {item.name.length > 10
                            ? item.name.slice(0, 10) + "..."
                            : item.name}
                        </h3>
                      </div>
                    </div>
                  </Link>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </div>
      )}

    </>
  );
};

export default Cart0;
